<template>
    <nav
        v-if="is_at_least_administrator"
        :class="{ active: navigating }"
        class="nibnut-sidenav"
        v-touch:swipe="swiped"
    >
        <ul class="nav">
            <router-link
                :to="{ name: 'home' }"
                v-slot="{ href, navigate }"
                custom
            >
                <li
                    :class="{ 'active': ($route.name === 'home') || ($route.name === 'ui-catalog') }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <home-icon :stroke-width="($route.name === 'home') || ($route.name === 'ui-catalog') ? 2 : 1" />
                        <span>{{ translate("Home") }}</span>
                    </base-link>
                </li>
            </router-link>
            <router-link
                :to="{ name: 'user.list' }"
                v-slot="{ href, navigate, isActive }"
                custom
            >
                <li
                    :class="{ 'active': isActive }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <users-icon :stroke-width="isActive ? 2 : 1" />
                        <span>{{ translate("Users") }}</span>
                    </base-link>
                </li>
            </router-link>
            <router-link
                :to="{ name: 'settings' }"
                v-slot="{ href, navigate, isActive }"
                custom
            >
                <li
                    :class="{ 'active': isActive }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <settings-icon :stroke-width="isActive ? 2 : 1" />
                        <span>{{ translate("Settings") }}</span>
                    </base-link>
                </li>
            </router-link>
            <li
                v-if="installable"
                class="nav-item"
            >
                <base-link
                    href="#"
                    @click.prevent="$emit('install')"
                >
                    <arrow-down-circle-icon />
                    <span>{{ translate("Install") }}</span>
                </base-link>
            </li>
        </ul>
        <div class="nibnut-sidenav-footer">
            <div v-if="!navigating">
                <capital-city-logo size="sm" /><br />
                &copy;&nbsp;{{ current_year }}<br />
                v.{{ app_version }}
            </div>
            <div v-else>
                <capital-city-logo /><br />
                &copy;&nbsp;{{ current_year }}&nbsp;{{ setting("customer_name") }}
            </div>
        </div>
    </nav>
</template>

<script>
import { profile_utilities, misc_utilities, string_utilities } from "@/nibnut/mixins"

import { BaseLink } from "@/nibnut/components"
import { HomeIcon, UsersIcon, SettingsIcon, ArrowDownCircleIcon } from "@/nibnut/icons"
import { CapitalCityLogo } from "@/custom/components"

import nibnut_logo from "@/assets/img/nibnut.png"

export default {
    mixins: [profile_utilities, misc_utilities, string_utilities],
    components: {
        BaseLink,
        HomeIcon,
        UsersIcon,
        SettingsIcon,
        ArrowDownCircleIcon,
        CapitalCityLogo
    },
    methods: {
        swiped (direction) {
            if((direction === "left") || (direction === "right")) this.$emit("navigate", (direction === "right"))
        }
    },
    computed: {
        nibnut_logo () {
            return nibnut_logo
        }
    },
    props: {
        navigating: {
            type: Boolean,
            required: true
        },
        installable: {
            type: Boolean,
            required: false
        }
    }
}
</script>
